import React, { Component } from 'react';

import Nav from './components/nav';
import Profile from './components/profile';
import Work from './components/work';
import Education from './components/education';
import Achievements from './components/achievements';

class App extends Component {
  render() {
    return (
        <div>
            <Nav />
            <main className="main">
                <Profile />
                <hr/>
                <Work/>
                <hr/>
                <Education />
                <hr/>
                <Achievements />
                <p className="reference">Referees - Available on request</p>
            </main>
        </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js